<template>
    <div class="m-3">
            Admin moduli...
    </div>
</template>

<script>
    export default {
        name: "Admin",
        components: {},
        props: {},
        data() {
            return {}
        },
        mounted() {
        },
        methods: {},
        computed: {},
        filters: {},
        watch: {}
    }
</script>

<style scoped>

</style>
